<script setup>
    const emit = defineEmits(['closeCancelModal', 'close']);
    function closeCancelModal() {
        emit('closeCancelModal');
    }

    function close() {
        emit('close');
    }

    // Escape and the initial focus both mean "Go Back": the safe choice keeps
    // the unapplied changes.
    const dialogEl = ref(null);
    const goBack = ref(null);
    const titleId = useId();
    const bodyId = useId();
    useDialog(dialogEl, { onEscape: closeCancelModal, initialFocus: goBack });
</script>

<template>
    <section ref="dialogEl" class="white-card-alert white-card-alert-cancel" role="alertdialog" aria-modal="true" :aria-labelledby="titleId" :aria-describedby="bodyId" tabindex="-1">
        <div class="content">
            <button type="button" @click.prevent="closeCancelModal" class="close-button" aria-label="Close">
                <SvgsClose />
            </button>
            <div>
                <h2 :id="titleId" class="headline-2">Changes not applied</h2>
                <p :id="bodyId" class="body-book">Are you sure you want to exit without applying your changes?</p>
                <div class="buttons-wrapper">
                    <button type="button" @click.prevent="close" class="delete small-heavy uppercase">Yes, Exit</button>

                    <button ref="goBack" type="button" @click.prevent="closeCancelModal" class="go-back small-heavy uppercase">Go Back</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .white-card-alert {
        z-index: 400;
        position: fixed;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;
        // Clear the iPhone home indicator.
        padding-bottom: calc(15px + env(safe-area-inset-bottom));

        // Focus starts on Go Back, not the dialog, but the dialog can still
        // take it on a re-focus.
        &:focus {
            outline: none;
        }

        .content {
            position: relative;
            padding: 50px 30px;
            background-color: $white;
            text-align: center;

            .close-button {
                position: absolute;
                top: 15px;
                right: 15px;
            }

            h2 {
                margin-bottom: 10px;
            }

            p {
                margin-bottom: 25px;
            }

            .buttons-wrapper {
                display: flex;
                flex-direction: column;

                button {
                    width: 100%;
                    max-width: 145px;
                    margin-right: auto;
                    margin-left: auto;
                    padding: 10px;
                    font-family: $title;
                    background-color: $gray-light;
                    color: $black;
                    &.delete {
                        margin-bottom: 20px;
                        background-color: $black;
                        color: $white;
                    }
                }
            }
        }
    }
</style>
